import { render, staticRenderFns } from "./SalesByProductGroup.vue?vue&type=template&id=69c63abc&"
import script from "./SalesByProductGroup.vue?vue&type=script&lang=js&"
export * from "./SalesByProductGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports